import { render, staticRenderFns } from "./TheVideo.vue?vue&type=template&id=6662b023"
import script from "./TheVideo.vue?vue&type=script&lang=ts"
export * from "./TheVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsMyLightBox: require('/usr/src/nuxt-app/components/elements/MyLightBox.vue').default})
